import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react'

import { Toast, NotificationToast } from '../components/ui/toast'

const TOAST_VARIANTS = {
  default: Toast,
  notification: NotificationToast,
}

const ToastContext = createContext()

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const toast = useCallback(
    ({ type, message, duration, noTimeout, variant, title }) => {
      const id = crypto.randomUUID()
      setToasts((prevToasts) => [
        ...prevToasts,
        { id, type, message, duration, show: true, noTimeout, variant, title },
      ])
      return id
    },
    [],
  )

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) =>
      prevToasts.map((currentToast) =>
        currentToast.id === id
          ? { ...currentToast, show: false }
          : currentToast,
      ),
    )
    setTimeout(() => {
      setToasts((prevToasts) =>
        prevToasts.filter((currentToast) => currentToast.id !== id),
      )
    }, 300)
  }, [])

  const value = useMemo(() => ({ toast, removeToast }), [toast, removeToast])

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="tw-absolute tw-right-4 tw-top-2 tw-inset-0 tw-pointer-events-none tw-z-[999999999] tw-flex tw-flex-col tw-gap-2 tw-items-end">
        {toasts.map(
          ({
            id,
            type,
            message,
            duration,
            show,
            noTimeout,
            variant = 'default',
            title = '',
          }) => {
            const ToastComponent = TOAST_VARIANTS?.[variant] || Toast

            return (
              <ToastComponent
                key={id}
                type={type}
                message={message}
                duration={duration}
                show={show}
                onClose={() => removeToast(id)}
                noTimeout={noTimeout}
                title={title}
              />
            )
          },
        )}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  return useContext(ToastContext)
}
